
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire6577"];
var parcelRegister = parcelRequire.register;
parcelRegister("1VAz6", function(module, exports) {

$parcel$export(module.exports, "OfferOptIn", () => $c7825126f7c4a24b$export$ae9b735e4e7dd969);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ctmKj = parcelRequire("ctmKj");

var $kfZjc = parcelRequire("kfZjc");

var $365zC = parcelRequire("365zC");

var $c0Nmf = parcelRequire("c0Nmf");

var $7pTac = parcelRequire("7pTac");
var $202BL = parcelRequire("202BL");

var $k7oBJ = parcelRequire("k7oBJ");

var $WJMov = parcelRequire("WJMov");

var $7q8J2 = parcelRequire("7q8J2");

var $r2uF6 = parcelRequire("r2uF6");

var $9X3VB = parcelRequire("9X3VB");

var $ai90S = parcelRequire("ai90S");
/**
 * @featureflags
 */ const $c7825126f7c4a24b$var$ENABLE_EXPERIMENTAL_SMS_CONSENT = (0, $c0Nmf.flags).isActive((0, $c0Nmf.flags).names.ENABLE_EXPERIMENTAL_SMS_CONSENT);
const $c7825126f7c4a24b$var$ENABLE_EXPERIMENTAL_INCENTIVE_FLOW = (0, $c0Nmf.flags).isActive((0, $c0Nmf.flags).names.ENABLE_EXPERIMENTAL_INCENTIVE_FLOW);
const $c7825126f7c4a24b$export$ae9b735e4e7dd969 = ()=>{
    const history = (0, $kfZjc.useHistory)();
    const intl = (0, $202BL.default)();
    const posthog = (0, $WJMov.usePostHog)();
    const [campaignId] = (0, $r2uF6.useAtom)((0, $9X3VB.campaignIdAtom));
    const [{ campaign: campaign }] = (0, $r2uF6.useAtom)((0, $9X3VB.campaignAtom));
    const [consentRequired] = (0, $r2uF6.useAtom)((0, $9X3VB.anyConsentRequiredAtom));
    const [dataLayer] = (0, $r2uF6.useAtom)((0, $9X3VB.dataLayerAtom));
    const [behavior] = (0, $r2uF6.useAtom)((0, $9X3VB.behaviorAtom));
    const [variableMap] = (0, $r2uF6.useAtom)((0, $9X3VB.variableMapAtom));
    const [persistedUser, setPersistedUser] = (0, $r2uF6.useAtom)((0, $9X3VB.persistUserAtom));
    const [userId, setUserId] = (0, $r2uF6.useAtom)((0, $9X3VB.userIdAtom));
    const [influencer, createInfluencer] = (0, $r2uF6.useAtom)((0, $9X3VB.createInfluencerAtom));
    const [, trackConversion] = (0, $r2uF6.useAtom)((0, $9X3VB.trackConversionAtom));
    const setOptedIn = (0, $r2uF6.useSetAtom)((0, $9X3VB.optedInAtom));
    const dispatchMessage = (0, $ai90S.usePostMessage)();
    const { orderId: orderId, name: name } = dataLayer || {};
    const email = dataLayer.email || persistedUser.email;
    const subtotal = dataLayer.subtotal || dataLayer.revenue;
    const requireConsent = {
        email: campaign?.useEmailConsent && !(0, $7q8J2.getPersistedUser)().emailConsent,
        sms: $c7825126f7c4a24b$var$ENABLE_EXPERIMENTAL_SMS_CONSENT ? campaign?.useSMSConsent : false // do not require if not enabled
    };
    const onSubmit = async function({ email: email, emailConsent: emailConsent }) {
        setPersistedUser({
            email: email,
            emailConsent: emailConsent
        });
        const SHOW_INCENTIVE = $c7825126f7c4a24b$var$ENABLE_EXPERIMENTAL_INCENTIVE_FLOW && behavior?.type === "incentive";
        const finalDestination = SHOW_INCENTIVE ? "/offer-code" : "/share";
        const conversionType = SHOW_INCENTIVE ? "claimDiscount" : "participation";
        let user;
        /**
     * because of how the API works, we don't want to call create influencer when the conversion type
     * is claimDiscount
     */ if (conversionType !== "claimDiscount") user = await createInfluencer([
            {
                identifier: email,
                name: name || email,
                revenue: subtotal,
                inviteId: dataLayer?.invite,
                transactionId: dataLayer?.transactionId,
                redirectVariables: variableMap,
                influencerId: userId,
                campaignId: campaignId,
                orderId: orderId,
                email: email,
                emailConsent: emailConsent
            }
        ]);
        const { data: data } = await trackConversion([
            {
                name: name || email || "guest",
                identifier: email || "guest",
                inviteId: dataLayer?.invite,
                transactionId: dataLayer?.transactionId,
                conversionType: conversionType,
                email: email,
                campaignId: campaignId
            }
        ]) || {};
        user = data?.influencer;
        // persist the influencer
        if (!userId && user?.id) setUserId(user.id);
        // notify the parent that an influencer was created
        dispatchMessage({
            type: "ics_influencer_created",
            data: {
                uid: user?.id
            }
        });
        setOptedIn(true);
        posthog?.identify(influencer?.id, {
            ...influencer,
            flavor: behavior?.flavor
        });
        posthog?.capture("offer_opt_in");
        history.push(finalDestination);
    };
    /**
   * localization strings
   */ const UNLOCK_INPUT = intl.formatMessage({
        id: "unlock.input",
        defaultMessage: "Your Email Address",
        description: "Label for an input to enter an email"
    });
    const UNLOCK_LABEL = intl.formatMessage({
        id: "unlock.label",
        defaultMessage: "Activate Offer",
        description: "Call to action to unlock offer"
    });
    // skip the email entry step
    (0, $acw62.useEffect)(()=>{
        // don't try anything
        if (consentRequired) return;
        if (campaign && email) onSubmit({
            email: email,
            emailConsent: true
        });
    }, [
        campaign
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $365zC.PageWrapper), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $365zC.Offer), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctmKj.Typography).P, {
                typoSize: "sm",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "optInMessage",
                    defaultMessage: "Let us know where to contact you with offer and reward updates. Unsubscribe anytime.",
                    description: "Prompts the user to tell us how to contact them for offer and reward updates"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctmKj.Div), {
                paddingLeft: "md",
                paddingRight: "md",
                children: !influencer.isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $365zC.CodeUnlocker), {
                    onSubmit: onSubmit,
                    defaultEmail: email,
                    termsURL: campaign?.termsAndConditionsURL,
                    privacyURL: campaign?.privacyPolicyURL,
                    requireConsent: requireConsent,
                    label: UNLOCK_INPUT,
                    unlockLabel: UNLOCK_LABEL
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ctmKj.Div), {
                    padding: "xlg",
                    textAlign: "center",
                    backgroundColor: "ambientLight",
                    borderRadius: "default",
                    marginBottom: "xlg",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7oBJ.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctmKj.Typography).P, {
                            marginTop: "none",
                            children: "Unlocking your offer..."
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("7pTac", function(module, exports) {

$parcel$export(module.exports, "default", () => $5665a8818306a5ca$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $202BL = parcelRequire("202BL");

var $3wBTA = parcelRequire("3wBTA");
function $5665a8818306a5ca$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $7WQrb.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $7WQrb.__rest)(nextProps, [
        "values"
    ]);
    return (0, $3wBTA.shallowEqual)(nextValues, values) && (0, $3wBTA.shallowEqual)(otherProps, nextOtherProps);
}
function $5665a8818306a5ca$var$FormattedMessage(props) {
    var intl = (0, $202BL.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $acw62.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $acw62.createElement(Component, null, $acw62.Children.toArray(nodes));
    return $acw62.createElement($acw62.Fragment, null, nodes);
}
$5665a8818306a5ca$var$FormattedMessage.displayName = "FormattedMessage";
var $5665a8818306a5ca$var$MemoizedFormattedMessage = $acw62.memo($5665a8818306a5ca$var$FormattedMessage, $5665a8818306a5ca$var$areEqual);
$5665a8818306a5ca$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $5665a8818306a5ca$export$2e2bcd8739ae039 = $5665a8818306a5ca$var$MemoizedFormattedMessage;

});



//# sourceMappingURL=OfferOptIn.4021825b.js.map
